export const aggridSearchBarConstants = {
  SEARCH_FOR_PRODUCT: 'SEARCH_FOR_PRODUCT',
  SEARCH_LOGS: 'SEARCH_LOGS',
  LOGS_SUCCESS: 'LOGS_SUCCESS',
  SET_SEARCH: 'SET_SEARCH',
};
